import { ChangeDetectorRef, Component, OnInit,Sanitizer } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { TFMService } from 'app/mock-api/tfm.service';
import { Router, RouterModule, TitleStrategy } from '@angular/router';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { DestinationListType02Component } from '../../destination-list/destination-list-type02/destination-list-type02.component';
import { DealsType01Component } from '../../deals/deals-type01/deals-type01.component';
import { DealsType02Component } from '../../deals/deals-type02/deals-type02.component';
import { SearchComponent } from 'app/layout/common/search-widget/search.component';
import { NgClass, NgIf, NgStyle, ViewportScroller } from '@angular/common';
import { StayListComponent } from 'app/layout/common/list-stay/stay-list.component';
import { ArticlesType01Component } from '../../articles/articles-type01/articles-type01.component';
import { ArticlesType02Component } from '../../articles/articles-type02/articles-type02.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { SlideBannerType01Component } from '../../slide-banner/slide-banner-type01/slide-banner-type01.component';


@Component({
  selector: 'banner-type04',
  templateUrl: './banner-type04.component.html',
  styleUrls: ['./banner-type04.component.css'],
  standalone: true,
  imports: [MatIconModule,SearchComponent,MatTabsModule,MatStepperModule, RouterModule, DestinationListType01Component,DestinationListType02Component, DealsType01Component,DealsType02Component, NgIf, StayListComponent, NgClass,ArticlesType01Component,ArticlesType02Component, MatTooltipModule,NgStyle, SlideBannerType01Component],
})
export class BannerType04Component implements OnInit {


  currentImageIndex = 0;
  public backgroundImages : any[] = [];
  public view: any = {
    selectedTab: 'flight',// Default tab;
    
    
  };
  constructor(private _tfmCartService: TFMCartService, private _cd: ChangeDetectorRef, private _router: Router, private _tfmService : TFMService, private scroller: ViewportScroller) {  }

  onScrollToAnchor() {
    this.scroller.scrollToAnchor('destination-section') 
  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;
      // this._tfmService.log("get site",this.view.site )

      this._tfmService.filterAndSend(this.view.site._links, "site-images").subscribe(res => {
        this.view.site.images = res.content;

        this.view.site.images.forEach(img => {
          var imgUrl = this._tfmService.getLink(img._links, "view");
          if (imgUrl)
            img.url = this._tfmService.getLink(img._links, "view").href;
          this.backgroundImages.push(img.url)
          this._tfmService.log(this.backgroundImages)
        });
        // this.view.bannerUrl = this.view.site.images.filter(x=>x.isFeatured && x.isActive).length > 0 ? this.view.site.images.filter(x=>x.isFeatured && x.isActive)[0] : null;
        // if (this.view.bannerUrl) {
        //   this.view.bannerImageClass = "bg-[url('" + this.view.bannerUrl.url + "')]";
        //   this._cd.detectChanges();
        // }
        // this._tfmService.log(this.view);
      });
    });

    this.startSlideshow();
  }

  selectedTab: string = 'flight'; // Default tab

  selectTab(tab: string) {
    this.view.selectedTab = tab;
    this._cd.detectChanges();
  }

  public tripChanged(tripData) {
    // this._tfmService.log(tripData);

    this.view.trip = tripData;

    this._tfmCartService.updateTrip(this.view.trip);

    this.redirectToResults();
  }
  public searchChanged(searchData) {
    // this._tfmService.log(searchData);

    this.view.search = searchData;

    this.redirectToResults();
  }
  public resultChanged() {

  }

  public redirectToResults() {
    if (this.view.trip && this.view.search) {
      //Do redirect....
      this._router.navigateByUrl("/search-results", {state:{view:this.view, type:this.view.selectedTab}});
    }
  }
  startSlideshow() {
    setInterval(() => {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.backgroundImages.length;
    }, 3000); // Change image every 2 seconds
  }

  get currentImage() {
    return this.backgroundImages[this.currentImageIndex];
  }
}
